export default __webpack_public_path__ + "static/Plots0002-87b60d8edc2264c6c1ee2ab9856ea859.jpg";